import * as yup from 'yup'
import { AutocompleteValueSchema } from '../../AutocompleteValueSchema'
import { REQUIRED_MESSAGE } from '../../constants'

export const ShipmentInfoSchemaObject = {
  /**
   * @example: { id: '123', text: 'Jane Doe' }
   */
  opsRep: AutocompleteValueSchema.nullable().required(REQUIRED_MESSAGE),
}

export const ShipmentInfoSchema = yup.object(ShipmentInfoSchemaObject)

export type TShipmentInfoSchema = yup.InferType<typeof ShipmentInfoSchema>
